import heading from "./heading";

export default function works() {
  const target = document.querySelector(".is-works");

  if (!target) return;

  heading();
}
